import { render, staticRenderFns } from "./DomTableItem.vue?vue&type=template&id=418cb0aa"
import script from "./DomTableItem.vue?vue&type=script&lang=js"
export * from "./DomTableItem.vue?vue&type=script&lang=js"
import style0 from "./DomTableItem.vue?vue&type=style&index=0&id=418cb0aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports